import { render, staticRenderFns } from "./wait_reviewDialog.vue?vue&type=template&id=7ea29eb8&scoped=true&"
import script from "./wait_reviewDialog.vue?vue&type=script&lang=js&"
export * from "./wait_reviewDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea29eb8",
  null
  
)

export default component.exports